<script>
import CompanyList from '../../components/company/CompanyList.vue'

export default {
  components: {
    CompanyList
  },
}
</script>


<template>
  <CompanyList
      endpoint="company"
  />
</template>
